import { useMutation } from '@tanstack/react-query'
import { toast } from 'sonner'

import { fetchWithHeaders } from 'utils'

import { GrapeAPIError, type GrapeAPIErrorType } from './GrapeAPIError'

export function useSyncPayrollProviderConfigs () {
  return useMutation<{ success: boolean }, GrapeAPIErrorType>({
    mutationFn: async () => {
      const response = await fetchWithHeaders('/api/web/admin/payroll_provider_configs/sync', {
        method: 'POST',
      })

      if (!response.ok) {
        const error = await response.json()
        throw GrapeAPIError({
          status: response.status,
          message: error.message || 'Failed to sync payroll provider configs',
          errors: error.errors,
        })
      }

      return response.json()
    },
    onSuccess: () => {
      toast.success('Payroll provider sync initiated. Please reload the page after a few minutes to see changes.')
    },
    onError: (error) => {
      toast.error(`Failed to sync payroll providers: ${error.message}`)
    }
  })
}
